import { Box, Card, CardContent, Paper, Skeleton, Stack } from "@mui/material";

import { useAppSelector } from "~/app/store";
import { createNumberSequence } from "~/lib/shared";
import { BatchSummaryDto } from "~/types/api";

import { BatchCard } from "./BatchCard";
import { selectBatchIds } from "./batchCards.slice";

function LoadingBatchCard() {
  return (
    <Card sx={{ width: "100%" }}>
      <CardContent>
        <Skeleton variant="rectangular" width="100%" height={56} />
        <Skeleton variant="text" width="100%" height={28} />
        <Skeleton variant="text" width="100%" height={28} />
      </CardContent>
    </Card>
  );
}

export function BatchList({
  batchesLoading,
  selectedBatch,
  onBatchSelected
}: {
  batchesLoading: boolean;
  selectedBatch: BatchSummaryDto | null;
  onBatchSelected: (batch: BatchSummaryDto) => void;
}) {
  const batchIds = useAppSelector(selectBatchIds);
  const rows = batchIds?.map((batchId) => (
    <BatchCard
      key={batchId}
      batchId={batchId}
      onBatchSelected={onBatchSelected}
      selectedBatchId={selectedBatch?.batchId || null}
    />
  ));

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
        gap: 3,
        width: "100%"
      }}
    >
      {batchesLoading ? (
        createNumberSequence(10).map((num) => <LoadingBatchCard key={num} />)
      ) : (
        <Paper sx={{ padding: 1 }}>
          <Stack spacing={1}>{rows}</Stack>
        </Paper>
      )}
    </Box>
  );
}
